import { atom } from 'recoil';

export const socketInitializeRecoil = atom<boolean>({
  key: 'socketInitializeRecoil',
  default: false,
});

export const refreshDataStateRecoil = atom<boolean>({
  key: 'refreshDataStateRecoil',
  default: false,
});

// 로딩 상태
export const fullLoadingStateRecoil = atom<boolean>({
  key: 'fullLoadingStateRecoil',
  default: false,
});
